module.exports = __webpack_public_path__ + "assets/training-item-audio-record.f6153700.svg";